<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Programs</b>
        <b-button type="button" variant="outline-primary" size="sm" class="float-right" @click="showCreateProgramModal = true">
          <span class="button-text">Add Program</span>
        </b-button>
      </b-card-header>

      <!-- List organization Programs -->
      <div v-if="programs.length > 0">
        <b-list-group v-for="program in programs" :key="program.id" flush>
          <b-list-group-item>
            <a href="#" @click.prevent="showUpdateProgramMod(program)">
              {{program.title !== 'Other' ? program.title : program.title_otherText}}
            </a>
            <img v-if="defaultProgramId == program.id " src="static/img/Primary.png" height="21" width="21">
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="programs.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>
              {{ !hasPrograms ? 'This Organization does not have any Programs.' : 'Howdy!' }}
            </p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <CreateProgramModal
      :showModal.sync = "showCreateProgramModal"
      :organizationId = "organizationId"
      :orgPrograms = "programs"
      :orgState="orgState"
    >
    </CreateProgramModal>

    <UpdateProgramModal
      :organizationId = "organizationId"
      :showModal.sync = "showUpdateProgramModal"
      :selectedProgramRec = "selectedProgramRec"
      :orgPrograms = "programs"
      :disableDelete = "disableDeleteVar"
      :orgState="orgState"
    >
    </UpdateProgramModal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CreateProgramModal from '@/components/Admin/CreateProgramModal'
  import UpdateProgramModal from '@/components/Admin/UpdateProgramModal'

  export default {
    name: 'OrganizationPrograms',
    props: {
      organizationId: Number,
      defaultProgram: String,
      programs: Array,
      orgState: {
        type: String,
        default: ''
      }
    },
    components: {
      CreateProgramModal,
      UpdateProgramModal
    },
    data: function () {
      return {
        showCreateProgramModal: false,
        showUpdateProgramModal: false,
        selectedProgram: null,
        disableDeleteVar: true,
        defaultProgramId: this.defaultProgram,
        selectedProgramRec: {}
      }
    },
    computed: {
      hasPrograms: function () {
        return this.programs.length > 0
      },
      ...mapGetters({
        updateOrganization: 'getUpdateOrganizationSuccess'
      })
    },
    watch: {
      updateOrganization: function (update) {
        this.defaultProgramId = update.defaultProgram
      }
    },
    methods: {
      // Temp Area for Update
      showUpdateProgramMod (programRec) {
        this.disableDeleteVar = true
        this.selectedProgramRec = programRec
        this.showUpdateProgramModal = true
      }
    },
    beforeDestroy () {
      this.$store.commit('RESET_VIEW_PROGRAM')
    }
  }
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Admin/ProgramList.vue